module.exports = __webpack_public_path__ + "img/history.4d52f8b5.svg";